/**
 * Axios instance for pilot API calls.
 *
 * Differences from the main http instance:
 * - Injects X-Pilot-Session header (session token from localStorage)
 * - Does NOT redirect to /login on 401
 * - Still uses humps for camel ↔ snake conversion
 */
import axios from 'axios'
import humps from 'humps'

const pilotHttp = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

pilotHttp.interceptors.request.use(request => {
  if (!request.headers) {
    request.headers = {} as any
  }

  // Inject session token from localStorage (council slug from URL)
  const councilSlug = window.location.pathname.split('/pilot/')[1]?.split('/')[0]
  if (councilSlug) {
    const sessionToken = localStorage.getItem(`pilot_session_${councilSlug}`)
    if (sessionToken) {
      request.headers['X-Pilot-Session'] = sessionToken
    }
  }

  // Decamelize POST/PUT/PATCH bodies
  const method = request.method?.toLowerCase()
  if (['post', 'put', 'patch'].includes(method || '')) {
    if (request.headers?.['Content-Type'] !== 'multipart/form-data') {
      request.data = humps.decamelizeKeys(request.data)
    }
  }

  return request
})

pilotHttp.interceptors.response.use(
  response => {
    const contentType = response.headers['content-type'] || ''
    if (typeof contentType === 'string' && contentType.includes('application/json')) {
      response.data = humps.camelizeKeys(response.data)
    }
    return response
  },
  error => Promise.reject(error),
)

export default pilotHttp
